import { render, staticRenderFns } from "./BatchOrder.vue?vue&type=template&id=33fff72c&scoped=true"
import script from "./BatchOrder.vue?vue&type=script&lang=js"
export * from "./BatchOrder.vue?vue&type=script&lang=js"
import style0 from "./BatchOrder.vue?vue&type=style&index=0&id=33fff72c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fff72c",
  null
  
)

export default component.exports